import { Award, ShieldCheck, Crosshair, Handshake, Trophy } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia } from "./SectionMedia";
import { useApp } from "../store";

const ICONS = [Award, ShieldCheck, Crosshair, Handshake, Trophy];

const VALUES_IMG =
  "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBleGVjdXRpdmUlMjBidXNpbmVzcyUyMHN0cmF0ZWd5JTIwY29uc3VsdGF0aW9uJTIwbWVldGluZyUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3ODkxNzgzMjR8MA&ixlib=rb-4.1.0&q=85";

export const Values = () => {
  const { c, t } = useApp();

  return (
    <section id="valeurs" data-testid="values-section" className="relative text-white grain overflow-hidden" style={{ background: "var(--sec-valeurs-bg, #0A1428)" }}>
      <img
        src={c("values_image") || VALUES_IMG}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-[0.08] pointer-events-none"
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="max-w-2xl mb-14">
          <Eyebrow>{t("values_eyebrow")}</Eyebrow>
          <h2 data-testid="values-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            {t("values_title")}
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ICONS.map((Icon, i) => (
            <Reveal key={i} delay={i * 0.07} className={i === 0 ? "lg:row-span-2" : ""}>
              <article
                data-testid={`value-card-${i + 1}`}
                className={`group h-full bg-white/[0.06] border border-[var(--accent-soft)]/10 p-7 transition-all duration-500 hover:border-[var(--accent)]/50 hover:-translate-y-1 ${
                  i === 0 ? "flex flex-col justify-between min-h-[280px]" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <Icon size={24} strokeWidth={1.5} className="text-[var(--accent-soft)]" />
                  <span className="font-mono2 text-xs text-white/25">V.0{i + 1}</span>
                </div>
                <div className={i === 0 ? "" : "mt-6"}>
                  <h3 className={`font-display font-semibold ${i === 0 ? "text-2xl sm:text-3xl" : "text-xl"}`}>
                    {c(`value_${i + 1}_title`)}
                  </h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed">
                    {c(`value_${i + 1}_desc`)}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <SectionMedia section="valeurs" />
      </div>
    </section>
  );
};
